import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { CheckoutField } from './fields.enum';

export enum ContactType  {
    Billing = "Billing",
    Delivery = "Delivery"
}



export enum CheckoutDeliveryType {
    PickUp = 'PickUp',
    Courier = 'Courier'
}

export const generateCheckoutForm = (): UntypedFormGroup => {
    return new UntypedFormGroup({
        [CheckoutField.invoiceRequested]: new UntypedFormControl(false),
        [CheckoutField.additionalDetails]: new UntypedFormControl(''),
        [CheckoutField.contacts]: new UntypedFormGroup({
            [CheckoutField.firstName]: new UntypedFormControl('', [Validators.required]),
            [CheckoutField.lastName]: new UntypedFormControl('', [Validators.required]),
            [CheckoutField.email]: new UntypedFormControl('', [Validators.required, Validators.email]),
            [CheckoutField.phone]: new UntypedFormControl('', [Validators.required]),
            [CheckoutField.legalPerson]: new UntypedFormControl(false),
            [CheckoutField.customFields]: new UntypedFormGroup({
                [CheckoutField.companyName]: new UntypedFormControl(''),
                [CheckoutField.kenitala]: new UntypedFormControl(''),
            })
        }),
        /*

        [CheckoutField.billingContact]: new UntypedFormGroup({
            [CheckoutField.firstName]: new UntypedFormControl('', [Validators.required]),
            [CheckoutField.lastName]: new UntypedFormControl('', [Validators.required]),

            [CheckoutField.phone]: new UntypedFormControl('', [Validators.required]),
            [CheckoutField.legalPerson]: new UntypedFormControl(false),
            [CheckoutField.companyName]: new UntypedFormControl(''),

            

            [CheckoutField.address]: new UntypedFormGroup({
                [CheckoutField.streetAddress]: new UntypedFormControl('', [Validators.required]),
                [CheckoutField.streetAddress2]: new UntypedFormControl('', ),
                [CheckoutField.city]: new UntypedFormControl('', [Validators.required]),
                [CheckoutField.zipCode]: new UntypedFormControl('', [Validators.required]),
                [CheckoutField.country]: new UntypedFormControl('IS', [Validators.required]),
            }),
         
        }),
        */

        [CheckoutField.deliveryContact]: new UntypedFormGroup({
            [CheckoutField.firstName]: new UntypedFormControl(''),
            [CheckoutField.lastName]: new UntypedFormControl(''),
         //   [CheckoutField.email]: new UntypedFormControl(''),
            [CheckoutField.phone]: new UntypedFormControl(''),
          //  [CheckoutField.kenitala]: new UntypedFormControl(''),
            [CheckoutField.legalPerson]: new UntypedFormControl(false),
         //   [CheckoutField.companyName]: new UntypedFormControl(''),
            [CheckoutField.address]: new UntypedFormGroup({
                [CheckoutField.streetAddress]: new UntypedFormControl(''),
                [CheckoutField.streetAddress2]: new UntypedFormControl('', ),
                [CheckoutField.city]: new UntypedFormControl(''),
                [CheckoutField.zipCode]: new UntypedFormControl(''),
                [CheckoutField.country]: new UntypedFormControl('IS'),
            }),
        }),
       // [CheckoutField.sameContact]: new UntypedFormControl(true, [Validators.required])
    })
}


